<span class="status-chip" [ngClass]="[colorClass, 'size-' + size]">
  {{ statusText }}
</span>
